"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_helmet_1 = require("react-helmet");
var Facebook_1 = __importDefault(require("./Facebook"));
var Twitter_1 = __importDefault(require("./Twitter"));
var ld_1 = require("../../utils/ld");
var SEO = function (_a) {
    var title = _a.title, pathname = _a.pathname, defaultTitle = _a.defaultTitle, defaultDescription = _a.defaultDescription, siteUrl = _a.siteUrl, defaultBanner = _a.defaultBanner, language = _a.language, twitter = _a.twitter, facebook = _a.facebook, buildTime = _a.buildTime;
    var seo = {
        title: title ? title + " : " + defaultTitle : defaultTitle,
        description: defaultDescription,
        image: (siteUrl && defaultBanner && "" + siteUrl + defaultBanner) || '',
        url: (siteUrl && pathname && "" + siteUrl + (pathname || '')) || ''
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.Helmet, { title: seo.title || '' },
            react_1.default.createElement("html", { lang: language || 'ja' }),
            react_1.default.createElement("meta", { name: "description", content: seo.description || '' }),
            react_1.default.createElement("meta", { name: "image", content: seo.image }),
            react_1.default.createElement("script", { type: "application/ld+json" }, JSON.stringify(ld_1.schemaOrgWebPage(siteUrl, language, defaultDescription, defaultTitle, buildTime, seo.image)))),
        react_1.default.createElement(Facebook_1.default, { description: seo.description || '', image: seo.image, title: seo.title || '', type: 'website', url: seo.url, name: facebook || '' }),
        react_1.default.createElement(Twitter_1.default, { title: seo.title || '', image: seo.image, description: seo.description || '', username: twitter || '' })));
};
exports.default = SEO;
//# sourceMappingURL=SEO.js.map